import React, { useEffect, useState } from "react";
import { Card, Table, Button, message, Switch } from "antd";
import ConnectorModal from "./CreateCustomConnector";
import ApiService from "../Components/apiService";
import { BASE_URL } from "../Components/Constant";
import { useNavigate } from "react-router-dom";

const CustomConnectorsTable = () => {
  const [connectors, setConnectors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const navigate = useNavigate();

  // Fetch connectors
  // Fetch connectors
const fetchConnectors = async () => {
  try {
    setLoading(true);
    const apiservice = new ApiService(
      `${BASE_URL}/connectors`, 
      { 'Content-Type': 'application/json' },
      'GET'
    );
    const responseForConnector = await apiservice.makeCall();

    console.log('Fetched connectors:', responseForConnector);

    // Ensure table has correct field names
    const mappedConnectors = (responseForConnector.connectors || []).map(item => ({
      ...item,
      id: item._id, // for navigation
      systemName: item.system_type, // map backend field to UI field
      active: item.is_active, // map backend field to UI field
    }));

    setConnectors(mappedConnectors);
  } catch (err) {
    message.error("Failed to load connectors");
  } finally {
    setLoading(false);
  }
};


  useEffect(() => {
    fetchConnectors();
  }, []);

  // Save connector
  const handleSave = async (values) => {
    console.log('Saving connector with values:', values);
    try {
      
      const payload = {
        connector: {
          name: values.name,
          system_type: values.systemName,
          description: values.description,
          is_active: values.active,
          version: '1.0.0',
        }
      };
  
      const apiservice = new ApiService(
        `${BASE_URL}/connectors`,
        { 'Content-Type': 'application/json' },
        'POST',
        payload,
      );
      const responseForCreatingCustomConnector = await apiservice.makeCall();

      console.log('Create connector response:', responseForCreatingCustomConnector);
      message.success("Connector created successfully");
      setIsModalVisible(false);
      fetchConnectors(); // Refresh table
    } catch (err) {
      console.log('Error creating connector:', err);
      message.error("Failed to create connector",err);
    }
  };

  const columns = [
    { title: "Name",
      dataIndex: "name", 
      key: "name",
      render: (text, record) => (
        <a onClick={() => navigate(`/setup/CustomConnectors/${record.id}`)}>{text}</a>
      ),
    
    },
    { title: "System Name", dataIndex: "systemName", key: "systemName" },
    { title: "Description", dataIndex: "description", key: "description" },
    {
      title: "Active",
      dataIndex: "active",
      key: "active",
      render: (active) => <Switch checked={active} disabled />,
    },
  ];

  return (
    <Card
      title="Custom Connectors"
      extra={
        <Button type="primary" onClick={() => setIsModalVisible(true)}>
          Create New Connector
        </Button>
      }
    >
      <Table
        dataSource={connectors}
        columns={columns}
        rowKey="_id"
        loading={loading}
      />
      {isModalVisible && (
        <ConnectorModal
          visible={isModalVisible}
          onCancel={() => setIsModalVisible(false)}
          onSave={handleSave}
        />
      )}
    </Card>
  );
};

export default CustomConnectorsTable;
